import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// SEC-002: request a short-lived signed URL (bound to file+user+action) instead of embedding the JWT
export async function getSignedFileUrl(path, action = "view") {
  const { data } = await api.post("/files/sign", { path, action });
  return `${API}/files/${data.path}?sig=${encodeURIComponent(data.sig)}`;
}

export default api;
